import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

interface INoteAdd {
  type: number;
  house_id: number;
  action_date: string;
  action_type: number;
  payment_method: number;
  month_share?: number;
  currency_type: string;
  amount: number;
  note?: string;
}
interface INoteDelete {
  id: number;
}
interface ITransactionDetail {
  id: number;
}

interface IAddNoteV2 {
  type: number;
  action_type: number;
  currency_type: string;
  payment_method: number;
  amount: number;
  house_ids?: Array<number>;
  invoice_ids?: Array<number>;
  month_share?: any;
  action_date: string;
  note?: string;
}

interface IModifyTransaction {
  id: number;
  type: number;
  action_type: number;
  currency_type: string;
  payment_method: number;
  amount: number;
  house_id?: number;
  invoice_ids?: Array<number>;
  action_date: string;
  note?: string;
}

interface IGetHouseList {
  page: number;
  page_size: number;
  house_type_id?: number;
  group_id?: number;
}

interface IModifyReservationNote {
  transaction_id: number;
  action_type: number;
  payment_method: number;
  amount: number;
  action_time: string;
  type: number;
  invoice_ids?: Array<number>;
  note?: string;
  format: string | 'v_2';
}

interface IAddReservationNote {
  reservation_code: string;
  action_type: number;
  payment_method: number;
  amount: number;
  type: number;
  action_time: string;
  invoice_ids?: Array<number>;
  note?: string;
  format: string;
}

const GET_GROUP_LIST_API = '/api/house_group/group_list';
const GET_HOUSE_TYPE_LIST_API = '/api/house_type/all';
const GET_TRANSACTION_HOUSE_LIST_API = 'api/transaction/house_list';
const NOTE_ADD_API = '/api/transaction/add';
const TRANSACTION_DETAIL_API = '/api/transaction/detail';
const NOTE_DELETE_API = '/api/transaction/delete';
const GET_CURRENCY_API = '/api/transaction/get_currency';
const NOTE_ADD_V2_API = '/api/transaction/add?format=v_2';
const MODIFY_TRANSANCTION_API = '/api/transaction/modify?format=v_2';
const MODIFY_RESERVATION_NOTE_API = '/api/reservation/modify_transaction';
const ADD_RESERVATION_NOTE_API = '/api/reservation/add_transaction';

@Injectable({
  providedIn: 'root',
})
export class NoteV2Service implements OnDestroy {
  addNoteRaw$ = new Subject<any>();

  constructor(private http: HttpClient) {}

  addNoteChange(value) {
    this.addNoteRaw$.next(value);
  }

  /** 获取全部房源分组 */
  getGroupList() {
    return this.http.get(GET_GROUP_LIST_API) as Observable<IHttpResponse>;
  }

  /** 获取房型列表 */
  getHouseTypeList() {
    return this.http.get(GET_HOUSE_TYPE_LIST_API) as Observable<IHttpResponse>;
  }

  /** 获取交易房源分组列表 */
  getTransactionHouseList(params: IGetHouseList) {
    const query = new HttpParams()
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`)
      .append('house_type_id', `${params.house_type_id}`)
      .append('group_id', `${params.group_id}`);
    return this.http.get(GET_TRANSACTION_HOUSE_LIST_API, { params: query }) as Observable<IHttpResponse>;
  }

  /** 新增记一笔 */
  addNote(params: any) {
    return this.http.post(NOTE_ADD_API, params) as Observable<IHttpResponse>;
  }

  /** 收支明细详情 */
  getTransactionDetail(params: any) {
    const query = new HttpParams().append('id', `${params.id}`);

    return this.http.get(TRANSACTION_DETAIL_API, { params: query }) as Observable<IHttpResponse>;
  }

  /** 修改记一笔 */
  modifyTransaction(params: any) {
    return this.http.post(MODIFY_TRANSANCTION_API, params) as Observable<IHttpResponse>;
  }

  /** 删除记一笔 */
  deleteNote(params: any) {
    return this.http.post(NOTE_DELETE_API, params) as Observable<IHttpResponse>;
  }

  /** 获取交易币种 */
  getCurrency() {
    const query = new HttpParams();
    return this.http.get(GET_CURRENCY_API, { params: query }) as Observable<IHttpResponse>;
  }

  /** 添加全局记一笔V2 */
  addNoteV2(params: any) {
    return this.http.post(NOTE_ADD_V2_API, params) as Observable<IHttpResponse>;
  }

  /** 修改收支页信息 */
  modifyReservationNote(params: any) {
    return this.http.post(MODIFY_RESERVATION_NOTE_API, params) as Observable<IHttpResponse>;
  }

  /** 添加订单详情页记账 */
  addReservationNote(params: any) {
    return this.http.post(ADD_RESERVATION_NOTE_API, params) as Observable<IHttpResponse>;
  }

  ngOnDestroy() {
    this.addNoteRaw$.complete();
  }
}
